<template>
  <RecommendedPackagePopUp
    :ctaText="ctaText"
    :showCloseButton="false"
    @clickCta="handleCtaClicked"
  />
</template>

<script>
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import RecommendedPackagePopUp from 'client/Pricing/ALaCarte/RecommendedPackagePopUp.vue';

const {
  description,
  location,
  text,
  section,
} = eventProperties;
const { paymentSetupModal } = eventLocations;

const betterValuePackageModule = 'BetterValuePackageModule';

export default {
  name: 'CheckoutPackageRecommendation',

  components: {
    RecommendedPackagePopUp,
  },

  computed: {
    ...mapGetters(betterValuePackageModule, [
      'betterValuePackage',
    ]),

    cannotCheckout() {
      const canSelfServeAddOns = this.$hasFeatureFlag(this.$featureFlags.purchaseAddOnsInProduct);
      return this.betterValuePackage?.addOns.length && !canSelfServeAddOns;
    },

    ctaText() {
      return this.cannotCheckout ? 'Contact Sales' : 'Replace Cart';
    },
  },

  methods: {
    handleCtaClicked(betterValuePackage, isSwitchBack) {
      let eventInfo = isSwitchBack
        ? {
          description: 'admin has switched back to original package',
          text: 'Switch Back',
        }
        : {
          description: `admin has clicked replace cart for ${betterValuePackage.displayName}`,
          text: 'Replace Cart',
        };
      if (this.cannotCheckout) {
        eventInfo = {
          description: 'admin has add-on(s) that are not part of any plan in cart and has clicked "Contact Sales"',
          text: 'Contact Sales',
        };
      }

      if (this.cannotCheckout) {
        this.$emit('open-modal');
      }
      EventHelper.triggerButtonClicked({
        [description]: eventInfo.description,
        [location]: paymentSetupModal,
        [section]: 'Checkout Modal',
        [text]: eventInfo.text,
      });
    },
  },
};
</script>
